"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRandomNumber = createRandomNumber;
exports.createRandomHexNumber = createRandomHexNumber;
const hexDigits = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
];
/**
 * Gets a random number from the minimum up to, and including, the maximum.
 * @param min minimum (inclusive)
 * @param max maximum (inclusive)
 * @returns integer
 */
function createRandomNumber(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
/**
 * Generate random hex string of wanted size
 * @param length length of the returned string
 * @returns
 */
function createRandomHexNumber(length) {
    let result = '';
    for (let x = 0; x < length; x++) {
        result += hexDigits[createRandomNumber(0, hexDigits.length - 1)];
    }
    return result;
}
//# sourceMappingURL=random.js.map